import { Grid, Stack, Typography } from '@mui/material';
import { Outcome, StyleObj } from '../../@types';
import { publishBetslipAnimationOrigin } from '../../utils/betslipAnimationOrigin';
import OddsDisplay from '../atoms/OddsDisplay';

import { mergeSx } from '../../utils/styles';

export type EventCardOutcomeCellBaseProps = {
  outcome: Outcome;
  onClick: () => void;
  outcomeCount: number;
  styles: StyleObj;
  disabled: boolean;
};

const EventCardOutcomeCellBase = ({
  outcome,
  onClick,
  outcomeCount,
  styles,
  disabled,
}: EventCardOutcomeCellBaseProps) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!disabled) {
      publishBetslipAnimationOrigin(event.currentTarget);
      onClick();
    }
  };

  return (
    <Grid
      data-event-card-section='outcome'
      sx={mergeSx(
        {
          flex: 1,
        },
        styles.gridItem
      )}
      size={12 / outcomeCount}
    >
      <Stack
        direction='row'
        onClick={handleClick}
        sx={mergeSx(
          {
            alignItems: 'center',
            justifyContent: 'space-between',
          },
          styles.container
        )}
      >
        <Typography sx={styles.label} noWrap title={outcome.shortName}>
          {outcome.shortName}
        </Typography>
        <OddsDisplay value={outcome.odds} sx={styles.odds} />
      </Stack>
    </Grid>
  );
};

export default EventCardOutcomeCellBase;
